export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-regular-oblique-web-ac96dc1d3de26f509e0df5f4eaadbd96.svg";